<template>
	<div>
		<Read/>
		<Create/>
	</div>
</template>

<script>
// @ is an alias to /src
import Read from '@/components/Section/Read.vue'
import Create from '@/components/Section/Create.vue'

export default {
  name: 'eclass-section',
  components: {
    Read,
    Create
  }
}
</script>
